import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import TemperatureChart from './components/TemperatureChart';
import Card from '../config/ChowaCard';
import SettingsForm from './components/SettingsForm';
import { useChowaTheme } from '../config/chowaThemeContext';
import { commonStyles } from '../../../common/components/Layout/DashboardLayout';
import classNames from 'classnames';
import { getTMSModel, isValidTMSModel } from './config/tmsModels';

const TMSDetail = () => {
  const { modelId } = useParams();
  const [wsStatus, setWsStatus] = useState('未接続');
  const { clearSeriesColor } = useChowaTheme();

  // URLパラメータからモデル情報を取得
  const modelInfo = getTMSModel(modelId);

  // TMSページではデフォルトテーマを使用
  useEffect(() => {
    if (isValidTMSModel(modelId)) {
      clearSeriesColor();
    }
  }, [clearSeriesColor, modelId]);

  // ページタイトルを動的に設定
  useEffect(() => {
    if (modelInfo && isValidTMSModel(modelId)) {
      document.title = `${modelInfo.name} - TMS監視システム`;
    }
    
    // コンポーネントアンマウント時にタイトルをリセット
    return () => {
      document.title = 'Chowa Dashboard';
    };
  }, [modelInfo, modelId]);

  // 無効なモデルIDの場合は404にリダイレクト
  if (!isValidTMSModel(modelId)) {
    return <Navigate to="/404" replace />;
  }


  if (!modelInfo) {
    return (
      <div className={commonStyles.layout.container}>
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <h2 className="text-2xl font-semibold text-gray-600 mb-2">
              TMSモデルが見つかりません
            </h2>
            <p className="text-gray-500">
              モデルID「{modelId}」は存在しません
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={commonStyles.layout.container}>
      <div className={commonStyles.layout.content}>
        <div className={classNames(
          commonStyles.grid.default,
          commonStyles.grid.responsive.lg
        )}>
          {/* 左側のカラム：温度モニタリング */}
          <div className="lg:col-span-2 space-y-6">
            {/* 温度モニタリング */}
            <Card className={commonStyles.card.padding.default}>
              <TemperatureChart modelId={modelId} modelName={modelInfo?.displayName || modelId} />
            </Card>
          </div>

          {/* 右側のカラム：設定 */}
          <div className="lg:col-span-1">
            <Card className={commonStyles.card.padding.default}>
              <SettingsForm wsStatus={wsStatus} setWsStatus={setWsStatus} modelId={modelId} />
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TMSDetail;
